import { render } from "./AllCategories.vue?vue&type=template&id=bacf087a&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"

import "./AllCategories.vue?vue&type=style&index=0&id=bacf087a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bacf087a"]])

export default __exports__